// src/com/rtd_term_pos/RtdTermPos.js
import React, { useState, useEffect, useRef } from 'react';
//import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { TopContainer, TopHeader, TopContent, NoDataBox, ControlLine } from '../../common/TopStyle';
import { AppObject } from '../../value/AppConst';
import SearchBox from '../../common/SearchBox';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { rtdTermPosListRepo } from '../../value/AppModel';
import { LIST_RTD_TERM_POS } from './RtdTermPosGql';
import { useAlertSetter } from '../../api/app-hook';
import RtdTermPosLine from './RtdTermPosLine';
import RtdTermPosView from './RtdTermPosView';

/**
 * 차량위치 리스트
 * @returns 
 */
export default function RtdTermPos() {
    const [posSelected, setPosSelected] = useState({});
    const [searchText, setSearchText] = useState('');
    const [sortInfo, setSortInfo] = useState({id: null, order: 0}); // -1 : descending, 0: no sorting, 1: ascending
    const [records, setRecords] = useState([]);
    const rtdTermPosListData = useReactiveVar(rtdTermPosListRepo);
    const addAlert = useAlertSetter();
    const loadRef = useRef(false);

    // ##### Call GraphQL to get List #####
    const [getRtdTermPosList, responseList] = useLazyQuery(LIST_RTD_TERM_POS, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: "위치리스트 조회 오류", message: [error.message]})
    });

    useEffect(() => {
        if(!loadRef.current) {
            const diff = new Date().getTime()/1000 - rtdTermPosListData.when;
            if(diff > 60) {
                getRtdTermPosList();
            }
            loadRef.current = true;
        }
        return () => {
            loadRef.current = false;
        }
    }, []);

    useEffect(() => {
        const txt = searchText ? searchText.trim().toLowerCase() : '';
        let list;
        if(txt.length > 0) {
            list = rtdTermPosListData.records.filter((item) => {
                if(item.vehPlates && item.vehPlates.toLowerCase().includes(txt)) return true;
                if(item.driverName && item.driverName.toLowerCase().includes(txt)) return true;
                return false;
            });
            // setRecords(list);
        }
        else {
            list = rtdTermPosListData.records;
            //setRecords(rtdTermPosListData.records);
        }

        if(sortInfo.id && sortInfo.order !== 0) {
            const newList = [...list].sort((a, b) => {
                const orderBy = sortInfo.order < 0 ? -1 : 1; // -1: descending, 1: ascending
                if(a[sortInfo.id] < b[sortInfo.id]) return -1 * orderBy;
                if(a[sortInfo.id] > b[sortInfo.id]) return orderBy;
                return 0;
            });
            list = newList;
        }

        setRecords(list);
    }, [rtdTermPosListData, searchText, sortInfo]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.rtdTermPosList) {
            rtdTermPosListRepo({when:new Date().getTime()/1000, records:data.rtdTermPosList});
        }
    };

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const onClickSorter = (id, sortState) => {
        setSortInfo({id, order: sortState});
    };

    return(
        <TopContainer>
            <TopHeader>
                차량위치 리스트
            </TopHeader>
            <ControlLine>
                <SearchBox
                    value={searchText}
                    onChangeText={onChangeSearchText}
                    disabled={responseList.loading}
                />
            </ControlLine>
            <RtdTermPosLine
                onClickSorter={onClickSorter}
                idSorted={sortInfo.id}
            />
            <TopContent>
                {
                    records.length === 0 ?
                    <NoDataBox />
                    :
                    <Box>
                        {
                            records.map((item, index) => {
                                if(item.vehInfoSeq === posSelected.vehInfoSeq) {
                                    return(
                                        <RtdTermPosView
                                            key={index}
                                            item={item}
                                            onClose={() => {
                                                setPosSelected({});
                                            }}
                                        />
                                    );
                                }
                                return(
                                    <RtdTermPosLine
                                        key={index}
                                        item={item}
                                        index={index}
                                        itemSelected={posSelected}
                                        onClick={(item, index) => {
                                            setPosSelected(item);
                                        }}
                                    />
                                )
                            })
                        }
                    </Box>
                }
            </TopContent>
        </TopContainer>
    );
}
